export default {
    audioEls: null,
    windownPlaying: null,
    WaveSurfer: null,

	init: function(WaveSurfer) {
        this.WaveSurfer = WaveSurfer;
        this.audioEls = document.querySelectorAll('.js-audio-widget');

        this.initAudioWidget();

        body.addEventListener('list:updated', () => {
            this.audioEls = document.querySelectorAll('.js-audio-widget');
            this.initAudioWidget();
        })
	},

    initAudioWidget: function(){
        if (!this.audioEls) {
            return;
        }

        this.audioEls.forEach(audioEl => {
            // Init player
            const waveContainer = audioEl.querySelector('.js-audio-widget-waves')
            const audioUrl = waveContainer.dataset.audioUrl;
            const waveColor = waveContainer.dataset.waveColor;

            const wavesurfer = this.WaveSurfer.create({
                container: waveContainer,
                waveColor: '#CCE3E5',
                progressColor: waveColor,
                url: audioUrl,
                barWidth: 4,
                barGap: 5,
                barRadius: 0,
                barHeight: 1,
                cursorWidth: 0,
                height: waveContainer.dataset.style === "small" ? 35 : 65
            })

            // Play audio
            const playButton = audioEl.querySelector('.js-audio-widget-button')

            if (playButton) {
                playButton.addEventListener('click', function(e){
                    e.preventDefault();

                    if (this.widgetPlaying) {
                        this.widgetPlaying.pause();
                    }

                    if (playButton.classList.contains('--active')) {
                        wavesurfer.pause();
                        playButton.classList.remove('--active')
                        this.widgetPlaying = null;
                    } else {
                        wavesurfer.play();
                        playButton.classList.add('--active')
                        this.widgetPlaying = wavesurfer;
                    }
                })
            }
        })
    },
}